import React from 'react';

const CheckoutFormContext = React.createContext();

export default CheckoutFormContext;
